import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import Typography from '@mui/material/Typography';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  onConfirm: (confirmed: boolean) => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  title,
  description,
  onConfirm,
}) => {
  const handleConfirm = () => {
    onConfirm(true);
    onClose();
  };

  const handleCancel = () => {
    onConfirm(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{description}</Typography>
      </DialogContent>
      <DialogActions>
      <button
            type="button"
            className="w-36 text-orange-600 py-2 m-2 px-4 rounded float-end"
            onClick={handleCancel}
          >
            Close
          </button>
          <button
            type="submit"
            className="w-36 bg-orange-600 text-white py-2 m-2 px-4 rounded hover:bg-orange-700 float-end"
            onClick={handleConfirm}
          >
            Confirm
          </button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;